import { RootState } from '~redux/store';

export const getRequest = (state: RootState) => state.request;
export const getIntent = (state: RootState) => state.intent;
export const getQrcode = (state: RootState) => state.qrcode;
export const getPaymentMethod = (state: RootState) => state.paymentMethod;
export const getPaymentConsent = (state: RootState) => state.paymentConsent;
